<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { cn } from '@/lib/utils'
import { ToastRoot, useForwardPropsEmits } from 'radix-vue'
import { toastVariants } from '.'

const props = defineProps({
  class: { type: String, default: '' },
  variant: { type: String, default: 'default' },
  onOpenChange: { type: Function, default: undefined }
})

const emits = defineEmits(['update:open'])

const delegatedProps = computed(() => {
  // eslint-disable-next-line no-unused-vars
  const { class: _, ...delegated } = props
  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <ToastRoot
    v-bind="forwarded"
    :class="cn(toastVariants({ variant }), props.class)"
    @update:open="onOpenChange"
  >
    <slot />
  </ToastRoot>
</template> 